import searchIcon from '../../../assets/chevron-down.svg'
import "./question.scss";
import ProgressBar from "../../molecules/progress-bar/progressBar";
import Datalist from "../../atoms/datalist/datalist";
import RadioButton from "../../atoms/radio-button/radioButton";
import RadioLiker from "../../atoms/radio-liker/radioLiker";
import SliderQuestion2 from "../../molecules/slider-question/sliderQuestion2";
import MoneyInput from "../../atoms/money-input/moneyInput";
import { IQuestion } from "../../../interfaces/IQuestion";
import SabiasQue from "../../molecules/sabias-que/sabiasQue";
import DatalistOpen from "../../atoms/datalist-open/DatalistOpen";
import ContainerQuest from '../container-question/ContainerQuest';

interface mentoriaQuestionProps {
	question: IQuestion;
	value: any;
	setData: any;
	formData: any;
	movePreviousQuestion: any;
	moveNextQuestion: any;
	error?: any;
	isSlider?: boolean;
	sliderValue?: number;
	sliderMaxValue?: number;
	parentId?: number;
	onCustomChange?: any;
}

const Question = (props: mentoriaQuestionProps) => {
	const { question, onCustomChange } = props;

	const handleChange = (e: any) => {
		props.setData(
			e.target.value,
			e.target.name,
			(e.target.type === "checkbox") ? e.target.type : null
		);
	};

	const filterComponent = () => {
		switch (question.type.id) {
			case 1:
				return (
					<div className="m-question__input__select-container" key={question.id}>
						<select
							className={`m-question__input__select-container__select`}
							onChange={handleChange}
							name={question.id + ""}
							id={question.id + ""}
						>
							<option value="" selected={!props.value} hidden>Selecciona</option>
							{(question.options || []).map((option) => {
								let parsedValue;
								try {
									parsedValue = JSON.parse(props.value)
								} catch {
									parsedValue = props.value
								}

								const isSelected = parsedValue?.id === option?.id;

								return (
									<option
										key={option.name}
										value={JSON.stringify(option)}
										selected={(option.id === props.value?.id) || isSelected}
									>
										{option.name}
									</option>
								)
							})}
						</select>
						<img
							src={searchIcon}
							alt="Dropdown menu"
							className='m-question__input__select-container__arrow'
						/>
					</div>);
			case 5:
			case 8:
				return (
					<input
						className="m-question__input__regular"
						value={props.value}
						onChange={handleChange}
						name={question.id + ""}
						placeholder="Escribe tu respuesta"
						type={question.type.name}
						required={question.required}
						key={question.id}
					></input>);
			case 6:
				return (
					<input
						className="m-question__input__regular"
						value={props.value}
						onChange={handleChange}
						name={question.id + ""}
						placeholder="Escribe tu respuesta"
						type="text"
						pattern="[0-9]+"
						required={question.required}
						key={question.id}
					></input>);
			case 2:
				return (
					<div className={`m-question__input__radio ${question.horizontal ? 'radio--horizontal' : ''}`}>
						{question.options &&
							question.options.map((option) => (
								<RadioButton
									id={question.id + ""}
									value={option}
									name={question.id + ""}
									isChecked={props.value?.id === option.id}
									label={option.name}
									onChange={handleChange}
									key={option.id}
								/>
							))}
					</div>
				);
			case 4:
				return (
					<div className="m-question__input__checkbox-container" onChange={handleChange}>
						{question.options &&
							question.options.map((option) => (
								<div
									key={option.name}
									className={`m-question__input__checkbox-container__checkbox ${props.value?.includes(option) ? "--input-selected" : ""}`}>
									<input
										type="checkbox"
										id={option.name}
										value={JSON.stringify(option)}
										name={question.id + ""}
										defaultChecked={props.value?.find((el: any) => el.id === option.id)}

									></input>
									<label
										htmlFor={option.name}
										className="m-question__input__checkbox-container__checkbox__title"
									>
										{option.name}
									</label>
								</div>
							))}
					</div>
				);
			case 12:
				return (
					<>
						<div className={`m-question__input__radioLiker ${question.horizontal ? '--radioliker' : ''}`}>
							{question.options &&
								question.options.map((option, index) => (
									<RadioLiker
										id={question.id + ""}
										value={option}
										name={question.id + ""}
										isChecked={props.value?.id === option.id}
										label={option.name}
										onChange={handleChange}
										key={option.id}
										pos={index + 1}
									/>
								))}
						</div>
						<label className="text">
							<span>{question.options[0].name}</span>
							<span>{question.options[2].name}</span>
							<span>{question.options[4].name}</span>
						</label>
					</>
				);
			case 3:
				return (
						<Datalist
							name={question.id + ""}
							id={question.id + ""}
							options={question.options || []}
							onChange={props.setData}
							value={props.value}
							onAsyncSearch={onCustomChange}/>);
			case 16:
				return (
					<DatalistOpen
						name={question.id + ""}
						id={question.id + ""}
						options={question.options || []}
						onChange={props.setData}
						value={props.value}
						onAsyncSearch={onCustomChange}
					/>);
			case 7:
				return (
					<div className="m-question__title-container">
						<img className="m-question__title-container__icon" src={question.help} alt={question.name} />
						<h2 className="m-question__title-container__title">{question.name}</h2>
						{
							question?.options?.map((option) => (
								<p key={option.id} className="m-question__title-container__text">
									{option.name}
								</p>
							))
						}
					</div>);
			case 10:
				return (
					<div className="m-sliderQuestion-container single">
						<div className="m-question">
							<input
								className="m-question__input__regular"
								value={props.value || ""}
								onChange={handleChange}
								name={question.id + ""}
								type={question.type.name}
								required={question.required}
								key={question.id}
							></input>
						</div>
					</div>);
			case 9:
			case 11:
				return (
					<SliderQuestion2
						parentId={props.parentId || 0}
						setData={props.setData}
						formData={props.formData}
						questions={question.childQuestions || []}
						key={props.parentId}
					/>);
			case 14:
				return (
					<MoneyInput
						name={question.id + ''}
						setValue={props.setData}
						key={question.id}
						value={props.value}
					/>);
			case 15:
				return (<SabiasQue img={question.help} description={question.options} />)
			default:
				return (
					<input
						className="m-question__input__regular"
						value={props.value || ""}
						onChange={handleChange}
						name={question.id + ""}
						placeholder="Escribe tu respuesta"
						type={'text'}
						key={question.id}
					></input>);
		}
	};

	return (
			<div className="m-question">
				<div className={`m-question__header ${props.isSlider ? "m-question__header--slider" : ""}`}>
					{!([15, 7].includes(question.type.id)) && (
						<h2 className={`m-question__header__title ${props.isSlider ? "m-question__header__title--slider" : "" }`} 
							id="slider" >
							{question.name}
						</h2>
					)}
				</div>
				{props.isSlider && (
					<div className="m-question__progress">
						<ProgressBar
							percentage={props.sliderValue || 0}
							onClick={() => { }}
							simple
						/>
					</div>
				)}
				<div className={`m-question__input ${question.horizontal ? "--horizontal" : ""}`}>
					{filterComponent()}
				</div>
			</div>
	);
};

export default Question;
